export const ScreenPaths = {
  MANAGEMENT: 'management',
  PURCHASE_HISTORY: 'purchase-history',
  TRANSACTION_REPORT: 'data-transaction-report',
  INTEGRATION_REPORT : "dealer-integration-report",
  HOME: 'home',
  API_DIRECTORY: 'api-directory',
  CHECKOUT: 'checkout',
  MY_APIS: 'my-apis'
};

export const API_V2_PREFIX = 'api-v2-';
export const API_TYPE = {
  REST: 'api',
  ASYNC: 'async-api'
}
export const CMF_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}
export const requiredApiFieldsForSpecArray = [
  'checkStatusAfterSeconds',
  '_links.status.href',
  '_links.result.href',
  'operationId',
  'status',
  'receivedDateTime',
  'updatedDateTime',
];
export const MSA_CONSENT_STATUS ={
  CONSENTED : 'consented',
  NOT_CONSENTED: 'not_consented'
} 
export const APP_METRICS_THEME = {
  DEALER_APP_METRICS: 'dealerAppMetrics',
  ISV_APP_METRICS: 'isvAppMetrics'
};
export const API_ERROR_THEME = {
  DEALER_API_ERROR: "dealerApiError",
  ISV_API_ERROR: "isvApiError",
};

export const UTILIZATION_REPORT_THEME = {
  DEALER_UTILIZATION_REPORT: 'dealerUtilizationReport',
  ISV_UTILIZATION_REPORT: 'isvUtilizationReport',
};

export const requiredApiFieldsForSpec = new Set(requiredApiFieldsForSpecArray);

export const Constants = {
  Subscription: {
    SUBSCRIBE: 'subscribe',
    ACTIVATION: 'subscription',
    HEADER_TITLE: "App Subscription Management",
    TITLE: 'Where would you like to use this app?',
    DESCRIPTION:
      'Select the dealership locations where you would like to use this subscription.',
    SEARCH_DEALERSHIP_LOCATIONS: 'Search locations by name or CMF number',
    STEPPER_SELECT_LOCATIONS: 'Select Locations',
    STEPPER_AGREE_TO_TERMS: 'Agree to Terms',
    STEPPER_MANAGE_API_SUBSCRIPTION_SETTINGS: 'API Subscription Settings',
    STEPPER_EDIT_API_FIELDS: 'Edit API Fields',
    STEPPER_PRIVACY_PROTECTION: 'Privacy Protection',
    STEPPER_VERIFY_DMS: 'Verify DMS Accounts',
    STEPPER_REVIEW: 'Review Subscription',
    AGREE_TO_TERMS_TITLE: 'Review and agree to terms',
    AGREE_TO_TERMS_DESCRIPTION: 'Agree to the following terms to subscribe to this app at your dealership.',
    REVIEW_TITLE: 'Review subscription',
    REVIEW_DESCRIPTION: 'Review the details and add any additional installation instructions or questions in the notes field below.',
    REMOVE_LOCATIONS_TITLE: 'Remove Locations',
    REMOVE_LOCATIONS_DESCRIPTION: 'Select the locations you would like to remove from this subscription.',
    SUMMARY: 'Subscription summary',
    COMPLETE_BUTTON: 'Complete Subscription',
    SUCCESS_PAGE_TITLE: 'Subscription successful!',
    SUCCESS_PAGE_DESCRIPTION:
      'Thank you for subscribing. You will receive a confirmation email with additional details.',
    MANAGEMENT_PAGE_TITLE: 'Subscription Management',
    TABLE_HEADER_ACTIVE: 'Active',
    TABLE_HEADER_PENDING: 'Pending',
    TABLE_HEADER_UNSUBSCRIBE: 'Unsubscribe',
    COL_APP_NAME: 'App Name',
    COL_LOCATION: 'Location(s)',
    COL_PUBLISHER: 'Publisher',
    COL_SUBSCRIBED_ON: 'Subscribed On',
    APP_DOCUMENTS_TITLE: 'App Documents',
    APP_DOCUMENTS_DESCRIPTION: 'See at a glance who authorized the app per location and access the documents to review or download.',
    COL_SIGNED_BY: 'Signed By',
    COL_BUSINESS_TITLE: 'Business Title',
    COL_DOCUMENTS: 'Documents (PDF)',
    API_INTEGRATION_TITLE: 'API Integrations',
    API_INTEGRATION_DESCRIPTION: 'For this app to be functional, you must enable each integration per location. Disabling will remove access at those locations.',
    MANAGE_DMS_ACCOUNTS_TITLE: 'Manage DMS Accounts',
    MENU_CONFIGURE_APP: 'Configure App',
    MENU_ADD_LOCATIONS: 'Add Locations',
    MENU_REMOVE_LOCATIONS: 'Remove Locations',
    MENU_MANAGE_INTEGRATION: 'Manage Integration',
    MENU_MANAGE_DMS_ACC: 'Manage DMS Accounts',
    MENU_APP_DOCUMENTS: 'App Documents',
    MENU_UNSUBSCRIBE: 'Unsubscribe',
    BACK_TO_MANAGEMENT_PAGE: 'Back to Subscription Management',
    PENDING_BANK_VERIFICATION_TITLE: 'Pending Bank Account Verification',
    PENDING_BANK_VERIFICATION_DESCRIPTION:'Thank you for subscribing. You will receive two micro deposit in your bank statement',
    PENDING_TITLE_FOR_APP_ACTIVATION: 'Pending App Subscription',
    PENDING_DESC_FOR_APP_ACTIVATION:'Your Subscription is pending. You will recieve an email from App Publisher shortly.',
    SHARE_EMAIL_HELPER_TEXT: 'Share subscription details via email',
    CONFIGURE_SUBSCRIPTION: 'Your subscription was confirmed,'
  },
  /* Sample Activation Constants for Test */
  Activation: {
    SUBSCRIBE: 'activate',
    ACTIVATION: 'activation',
    HEADER_TITLE: "App Activation Management",
    TITLE: 'Where would you like to use this app?',
    DESCRIPTION:
      'Select the dealership locations where you would like to activate this app.',
    SEARCH_DEALERSHIP_LOCATIONS: 'Search locations by name or CMF number',
    STEPPER_SELECT_LOCATIONS: 'Select Locations',
    STEPPER_AGREE_TO_TERMS: 'Agree to Terms',
    STEPPER_MANAGE_API_SUBSCRIPTION_SETTINGS: 'API Subscription Settings',
    STEPPER_EDIT_API_FIELDS: 'Edit API Fields',
    STEPPER_PRIVACY_PROTECTION: 'Privacy Protection',
    STEPPER_VERIFY_DMS: 'Verify DMS Accounts',
    STEPPER_REVIEW: 'Review Activation',
    AGREE_TO_TERMS_TITLE: 'Review and agree to terms',
    AGREE_TO_TERMS_DESCRIPTION: 'Agree to the following terms to activate this app at your dealership.',
    REVIEW_TITLE: 'Review activation',
    REVIEW_DESCRIPTION: 'Review the details and add any additional installation instructions or questions in the notes field below.',
    REMOVE_LOCATIONS_TITLE: 'Remove Locations',
    REMOVE_LOCATIONS_DESCRIPTION: 'Select the locations you would like to remove from this activation.',
    SUMMARY: 'Activation summary',
    COMPLETE_BUTTON: 'Complete Activation',
    SHARE_EMAIL_HELPER_TEXT: 'Share activation details via email',
    SUCCESS_PAGE_DESCRIPTION:
    'Thank you for activating. You will receive a confirmation email with additional details.',
    SUCCESS_PAGE_TITLE: 'Activation successful!',
    PENDING_TITLE_FOR_APP_ACTIVATION:'Pending App Activation',
    PENDING_DESC_FOR_APP_ACTIVATION:'Your Activation is pending. You will recieve an email from App Publisher shortly.',
    CONFIGURE_SUBSCRIPTION: 'Your activation was confirmed,'
  },
  LOCATIONS: 'Location(s)',
  NOT_IN_MARKETPLACE: 'Not in Marketplace',
  BROWSE_FORTELLIS_MARKETPLACE: 'Browse Fortellis Marketplace',
  DOWNLOAD_REPORT: 'Download Report',
  /* Not in use */
  MANAGE_SUBSCRIPTION: 'Manage Subscription',
  SUCCESS_MSG: 'Congrats on your new subscription!',
  ALREADY_SUCCESS_MSG: 'You have already subscribed.',
  INFO_MESSAGE: {
    PART1: 'Review and ',
    PART2: 'accept the terms and conditions ',
    PART3: 'for new data integration agreements below'
  },
  SUBSCRIPTION_SUMMARY: 'Subscription Summary',
  OPTIONS: 'Options',
  COMPLETE_APP_SETUP: 'Complete App Setup',
  OPENING_PUBLISHER_WEBSITE:
    'We are sending you to the App Publisher website to complete your setup...',
  ALLOW_POPUPS:
    'Unable to open publisher website, please allow browser to open pop-ups from https://ds.fortellis.io',
  POPUPS_BLOCKED: 'Pop-ups Blocked',
  TEST_BUILD: 'test build',
  REVIEW_PURCHASE_CART:'Review & Purchase',
  BROWSE_API_DIRECTORY: "Browse API Directory",
  MY_CART:'My Cart',
  NO_APIS_IN_CART:'There are no APIs in your cart.',
  API_REVIEW_CART: 'Review Cart',
  API_CONFIGURATION:'API Configuration',
  PRICING:'Pricing',
  TERMS_AND_CONDITIONS:'Terms and Conditions',
  CONFIGURE_CMF_NUMBER: 'Configure CMF Number',
  TERMS_AND_CONDITIONS_TEXT:'Review the Terms and Conditions of each API.',
  TERMS_AND_CONDITIONS_TEXT_FOR_SINGLE_RESOURCE:'Review the Terms and Conditions API.',
  PRICING_TEXT:'Select a Pricing plan for each API.',
  CONFIGURE_WEBHOOK_AND_FIELDS:'Configure the webhook and fields of each API selected.',
  REVIEW_OR_REMOVE_APIS:'Order summary',
  CONFIGURE_CMF_DESCRIPTION: 'Select the CMF number or Store Name to invoice the Install Fee for each Bundle/API.',
  COMPLETE_PURCHASE:'Complete Purchase',
  CONTINUE:'Continue',
  DOWNLOAD_ALL:'Download All',
  AGREE_TERMS_CONDITIONS:'I agree to all the Terms and Conditions.',
  API_SUCCESSFULLY_PURCHASED_MESSAGE: 'You have successfully purchased the APIs.',
  API_PLAN_UPDATED:'The new pricing plan selected has been updated for the API',
  BUNDLE_PLAN_UPDATED:'The new pricing plan selected has been updated for the Bundle',
  BILLING_CYCLE:'This pricing change takes effect from the next billing cycle.',
  API_PURCHASE_FAILED_MESSAGE:'Failed to complete the purchase. Try again after sometime.',
  NEW_SECRET_SUCCESSFULLY_GENERATED_MESSAGE: 'A new key has been generated',
  APP_STATUSES: {
  IN_REVIEW: 'In Review',
  APPROVED: 'Approved',
  PROVISIONING: 'Provisioning',
  PROVISIONING_FAILED: 'Provisioning Failed',
  DRAFT: 'Draft',
  REGISTERED: 'Registered',
  ERROR: 'Error',
  },
  APP_REFRESH_INTERVAL_MS: 6000,
  API_INTEGRATIONS_TITLE: 'API Integrations',
  LOADING: 'Loading...',
  NO_DATA_FOUND: 'No data found',
  BUNDLE_SUFFIX: '- Bundle',
};

export const PAGE_TITLE = {
  DASHBOARD: "Dealer Portal | Dashboard",
  MY_APIS: "Dealer Portal | My APIs",
  DEALER_PORTAL: "Dealer Portal",
  DIRECTORY: "Dealer Portal | API Directory",
  INTEGRATIONS: "Dealer Portal | Integrations",
  APP_MANAGEMENT: "App Management",
};


export const RESOURCE_TYPES = {
  API: 'api',
  ASYNC_API: 'async-api',
  BUNDLE: 'bundle',
};

export const BUNDLE_TYPE = {
  PRICE: 'price',
  GENERAL: 'general'
}

export const NOTIFICATION_TYPES = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};